import React from 'react';
import {Link, browserHistory} from 'react-router';
import cs from 'classnames';

class NavBar extends React.Component {
    static propTypes = {
        onToggle: React.PropTypes.func.isRequired,
        toggleMe: React.PropTypes.func.isRequired,
        path: React.PropTypes.string.isRequired,
        toggled: React.PropTypes.bool.isRequired,
        onExit: React.PropTypes.func.isRequired,
        user: React.PropTypes.object.isRequired,
    };

    componentWillMount() {
        this.state = {
            foodOpen: false,
            financeOpen: false,
        };
    };

    render() {
        const {onToggle, onExit, path, toggled, toggleMe, user} = this.props;
        return (
            <div className="sidebar-panel offscreen-left">
                <div className="brand">
                    <div className="brand-logo" style={{
                        margin: "0",
                        padding: "5px 0",
                    }}>
                        <img src="/images/logo_white.png" height="42" alt="Школа Афины"/>
                    </div>
                    <a href="#" className="toggle-sidebar hidden-xs hamburger-icon v3"
                       onClick={onToggle}>
                        <span/>
                        <span/>
                        <span/>
                    </a>
                </div>

                <nav role="navigation" style={{'overflowY': 'hidden'}}>
                    <ul className="nav">
                        <li className={cs({'active': path === '/'})}>
                            <Link onClick={(e) => {
                                toggled && toggleMe(e);
                                browserHistory.push("/");
                            }}>
                                <i className="fa fa-home"/>
                                <span>Головна</span>
                            </Link>
                        </li>
                        <li className={ cs({"menu-accordion": 1, "open": this.state.foodOpen}) }>
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                    foodOpen: !this.state.foodOpen
                                });
                            }}>
                                <i className="fa fa-cutlery"/>
                                <span>Харчування</span>
                            </a>
                            <ul className="sub-menu">
                                <li className={cs({'active': path === '/food'})}>
                                    <Link onClick={(e) => {
                                        toggled && toggleMe(e);
                                        browserHistory.push("/food")
                                    }}>
                                        <i className="fa fa-shopping-cart"/>
                                        <span>Замовлення харчування</span>
                                    </Link>
                                </li>
                                <li className={cs({'active': path === '/history'})}>
                                    <Link onClick={(e) => {
                                        toggled && toggleMe(e);
                                        browserHistory.push("/history")
                                    }}>
                                        <i className="fa fa-archive"/>
                                        <span>Замовлення за період</span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li className={ cs({"menu-accordion": 1, "open": this.state.financeOpen}) }>
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                    financeOpen: !this.state.financeOpen
                                });
                            }}>
                                <i className="fa fa-money"/>
                                <span>Фінанси</span>
                            </a>
                            <ul className="sub-menu">
                                <li className={cs({'active': path === '/finance'})}>
                                    <Link onClick={(e) => {
                                        toggled && toggleMe(e);
                                        browserHistory.push("/finance")
                                    }}>
                                        <i className="fa fa-shopping-cart"/>
                                        <span>Квитанції</span>
                                    </Link>
                                </li>
                                <li className={cs({'active': path === '/act'})}>
                                    <Link onClick={(e) => {
                                        toggled && toggleMe(e);
                                        browserHistory.push("/act")
                                    }}>
                                        <i className="fa fa-archive"/>
                                        <span>Акт звірки</span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                        <li className={cs({'active': path === '/docs'})}>
                            <Link onClick={(e) => {
                                toggled && toggleMe(e);
                                browserHistory.push("/docs");
                            }}>
                                <i className="fa fa-file"/>
                                <span>Документи</span>
                            </Link>
                        </li><li>
                            <a href={"http://www.athens.kiev.ua/php?login="+user.login+"&ph=" + user.pwdHash}>
                                <i className="fa fa-university"/>
                                <span>Навчання</span>
                            </a>
                        </li>
                        <li>
                            <Link onClick={(e) => {
                                toggled && toggleMe(e);
                                onExit();
                            }}>
                                <i className="fa fa-sign-out"/>
                                <span>Вихід</span>
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        );
    }
}

export default NavBar;



/** WEBPACK FOOTER **
 ** ./src/modules/layout/NavBar.js
 **/